module.exports = require('react-router-dom');
module.exports.routerRedux = require('react-router-redux');